import React, { useState } from "react";
import { Button, Input } from "antd";
import ModalComponent from "../modalComponent/ModalComponent";
import { visitApiUpsellProvider } from "../../lib/api/providers";
import { handleError } from "../../modules/presence/api/api";

const ModifyComment = ({ visitId = "", path = {}, kpi, isInEndVisitStatement = false }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const response = kpi.response || {};
  const [comment, setComment] = useState(response.response);

  return (
    <div>
      <Button onClick={() => setIsModalVisible(true)}>Modifier le commentaire</Button>
      <ModalComponent title={kpi.long_label} visible={isModalVisible} closeModal={() => setIsModalVisible(false)}>
        <div>
          <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
        </div>
        <Input
          className="p-content-item p-mrg-bot-l p-mrg-left"
          value={comment}
          onChange={text => setComment(text.target.value)}
          placeholder={"Commentaire"}
        />
        <Button
          className="p-content-item p-mrg-bot-l p-mrg-left"
          type={"secondary"}
          loading={isLoading}
          large={true}
          disabled={isLoading}
          onClick={() => {
            setIsModalVisible(false);
          }}
        >
          Annuler
        </Button>
        <Button
          className="p-content-item p-mrg-bot-l p-mrg-left"
          type={"primary"}
          loading={isLoading}
          large={true}
          disabled={isLoading}
          onClick={async () => {
            setIsLoading(true);
            try {
              const responseUpdated = kpi.response || {};
              responseUpdated.response = comment;

              kpi.response = responseUpdated;
              await visitApiUpsellProvider.post(`/modifycomment/${visitId}`, { kpi, ...path, isInEndVisitStatement });
              setIsLoading(false);
              setComment("");
              window.location.reload(false);
            } catch (e) {
              handleError(e);
              console.log(e);
              setIsLoading(false);
            }
          }}
        >
          Enregistrer
        </Button>
      </ModalComponent>
    </div>
  );
};

export default ModifyComment;



// WEBPACK FOOTER //
// src/components/visit/ModifyComment.js